module.exports = __webpack_public_path__ + "img/greypercent.7b240209.svg";